import React from 'react';

export default function Footer() {
  return (
    <footer className="py-6 text-center border-t border-gray-800 text-gray-500 text-sm">
      © {new Date().getFullYear()} Ali Fayed. All rights reserved.
    </footer>
  );
}
